export type LogFunc = (message: string, ...other: any[]) => void;

export enum LoggingLevel {
  log = 'Trace',
  debug = 'Debug',
  info = 'Info',
  warn = 'Warn',
  error = 'Error',
  fatal = 'Fatal'
}

export type LogLevelKeys = keyof typeof LoggingLevel;

export interface Loggable {
  log: LogFunc;
  debug: LogFunc;
  info: LogFunc;
  warn: LogFunc;
  error: LogFunc;
  fatal: LogFunc;
  dump: () => LoggerError[];
}

export enum LoggingModule {
  profile = 'Profile: ',
  authService = 'AuthService: ',
  booking = 'Booking: ',
  dateUtils = 'DateUtils: ',
  deviceInfoService = 'DeviceInfoService: ',
  errorBoundary = 'ErrorBoundary: ',
  facilityDetails = 'FacilityDetails: ',
  financialAssistance = 'FinancialAssistance: ',
  fileUploads = 'FileUploads: ',
  findProvider = 'FindProvider: ',
  getCare = 'GetCare: ',
  glossary = 'Glossary: ',
  landing = 'Landing: ',
  linkingServices = 'LinkingServices: ',
  loading = 'Loading: ',
  navigation = 'Navigation: ',
  openMapApp = 'OpenMapApp: ',
  redux = 'Redux: ',
  responseInterceptors = 'ResponseInterceptors: ',
  secureStorageService = 'SecureStorageService: ',
  splash = 'Splash: ',
  switchAccount = 'SwitchAccount: ',
  tooltips = 'Tooltips: ',
  resetAccountAccess = 'ResetAccountAccess: ',
  appsFlyer = 'AppsFlyer: '
}

export interface LoggerError {
  type: LoggingLevel;
  message: string;
  data?: any;
  timestamp: Date;
}
